import React from 'react';

type LinkProps = {
  url: string;
  external?: boolean;
  children?: React.ReactNode;
  itemClassName?: string;
  anchorClassName?: string;
  handler?: React.MouseEventHandler<HTMLAnchorElement>;
  keyboardHandler?: React.KeyboardEventHandler<HTMLAnchorElement>;
};

export const Link = ({
  url,
  external = false,
  children,
  itemClassName,
  anchorClassName,
  handler,
  keyboardHandler,
}: LinkProps) => (
  <li suppressHydrationWarning className={itemClassName}>
    <a
      className={anchorClassName}
      href={url}
      {...(external && { target: '_blank', rel: 'noopener' })}
      onClick={handler}
      onKeyDown={keyboardHandler}
      suppressHydrationWarning
    >
      {children}
    </a>
  </li>
);
